module.exports = __webpack_public_path__ + "1f822c3da749b9f859c369683e439065.svg";